/**
 * Estado do fluxo de resposta de alerta (espelho do guardian-app).
 * Baseado na última action dos tickets do alerta.
 */

export function normalizeTicketAction(action) {
  return String(action || "")
    .toLowerCase()
    .replace(/\s+/g, "_");
}

export function sortTicketsByDateDesc(tickets = []) {
  return [...tickets].sort((a, b) => {
    const dateA = new Date(a.ticket_created_at || a.created_at || 0).getTime();
    const dateB = new Date(b.ticket_created_at || b.created_at || 0).getTime();
    return dateB - dateA;
  });
}

export function getLastTicket(tickets = []) {
  if (!tickets.length) return null;
  return sortTicketsByDateDesc(tickets)[0];
}

/**
 * @returns {"needs_equipe"|"needs_resposta"|"already_answered"|"rejected_needs_new"}
 */
export function resolveAlertResponseState(tickets = []) {
  const last = getLastTicket(tickets);
  if (!last) return "needs_equipe";

  const lastAction = normalizeTicketAction(last.action);

  switch (lastAction) {
    case "equipe_enviada":
      return "needs_resposta";
    case "respondido_processo_sucessao":
      return "already_answered";
    case "resposta_rejeitado":
      return "rejected_needs_new";
    case "aguardando_resposta":
    case "criado":
    default:
      return "needs_equipe";
  }
}

export function getInitialPageForState(state) {
  return state === "needs_resposta" || state === "rejected_needs_new" ? 2 : 1;
}

export function isAlreadyAwareAction(action) {
  const normalized = normalizeTicketAction(action);
  return (
    normalized === "aguardando_resposta" ||
    normalized === "equipe_enviada" ||
    normalized === "respondido_processo_sucessao" ||
    normalized === "resposta_rejeitado"
  );
}

export function pickAlertId(item) {
  if (!item || typeof item !== "object") return null;
  return item.alert_id || item.alert?.id || item.id || null;
}

export function classifyAlertType(description = "") {
  const text = String(description).toLowerCase();
  if (text.includes("incênd") || text.includes("incend") || text.includes("queim")) {
    return "incendio";
  }
  if (text.includes("desmat")) {
    return "desmatamento";
  }
  return "outro";
}

export function severityTone(description = "") {
  const text = String(description).toLowerCase();
  if (text.includes("grave") || text.includes("alto") || text.includes("high")) {
    return "high";
  }
  if (text.includes("medio") || text.includes("médio") || text.includes("medium")) {
    return "medium";
  }
  return "low";
}
